import Calendar from './components/calendar'
import CalendarSlider from './components/slider'

export default function install(Vue) {
  Vue.component('calendar', Calendar)
  Vue.component('calendar-slider', CalendarSlider)
}



// WEBPACK FOOTER //
// ./src/js/calendar/index.js